<template>
    <div style="padding: 15px; padding-bottom:0; color:#000; margin-bottom: 50px;" :id="qid">
        <div class="row">

            <!-- Messages -->
            <div class="col-md-12 quiz-message-row"
                 v-bind:class="{'alert-success': validate(), 'alert-danger': !validate()}">
                <table>
                    <tr>
                        <td class="text-left">Question #{{idx + 1}}</td>
                        <td class="text-right" v-html="validationErrorMessage ? validationErrorMessage : 'This question is valid!'"></td>
                    </tr>
                </table>
            </div>

            <!-- Question Properties -->
            <div class="col-md-4 quiz-left-column question-row">
                <input type="hidden" :name="'questions['+idx+'][qid]'" :value="qid"/>
                <input type="hidden" :name="'questions['+idx+'][level]'" :value="level"/>
                <input type="hidden" :name="'questions['+idx+'][suggestedAnswerOid]'" :value="suggestedAnswerOid"/>
                <b>{{level === 1 ? 'Easy' : level === 2 ? 'Medium' : 'Hard'}}</b>
                <br/>
                <input type="hidden" :name="'questions['+idx+'][type]'" :value="type"/>
                <select v-model="type"
                        title="type"
                        v-bind:class="{'text-danger': type===null}">
                    <option selected disabled :value="null">select type</option>
                    <option v-for="currentType in questionTypes" :value="currentType">
                        {{camelCaseToWords(currentType)}}
                    </option>
                </select>
                <br/><br/>

                <input type="hidden" :name="'questions['+idx+'][pictureUrl]'" :value="pictureUrl"/>
                <div align="center" style="margin-bottom: 10px;" v-if="pictureUrl !== ''">
                    <a :href="pictureUrl" target="_blank" tabindex="-1">
                        <img :src="pictureUrl" style="max-height: 50px; max-width: 50px;"/>
                    </a>
                </div>
                <quiz-image-upload
                        :qid="qid"
                        :imageUploadRoute="imageUploadRoute"
                        v-on:quizImageUploaded="newImageUploaded"
                >
                </quiz-image-upload>
                <input type="hidden" :name="'questions['+idx+'][pictureUrl]'" :value="pictureUrl"/>
            </div>

            <!-- Question Text -->
            <div class="col-md-8 quiz-text-column question-row">
                <input type="hidden" :name="'questions['+idx+'][text][XX_en]'" :value="questionText"/>
                <textarea title="english"
                          rows="6"
                          dir="auto"
                          v-model="questionText"
                          onkeyup="preview(this.value)"
                          onfocus="preview(this.value);">
                </textarea>
            </div>
        </div>

        <!-- Options -->
        <quiz-english-master-correction-option
                v-for="(option, oidx) in options"
                ref="options"
                v-on:setSuggestedAnswer="setSuggestedAnswer"
                :questionIdx="idx"
                :key="option.oid"
                :oid="option.oid"
                :isSuggestedAnswer="isSuggestedAnswer(option.oid)"
                :questionType="type"
                :idx="oidx"
                :iisCorrect="option.isCorrect"
                :ioption-text="option.text.XX_en"
        >
        </quiz-english-master-correction-option>
    </div>
</template>


<script>
    export default {
        props: {
            'idx': Number,
            'iqid': String,
            'itype': String,
            'level': Number,
            'iquestionText': String,
            'ipictureUrl': String,
            'ioptions': Array,
            'imageUploadRoute': String,
            'questionTypes': Array,
            'isuggestedAnswerOid': String,
        },

        // the initial props are overwritten whenever the parent issues a re-rendering
        // (e.g. on adding/deleting questions), so we store them when the component
        // is loaded the first time, so we keep the user's changes.
        data: function() {
            return {
                qid: this.iqid,
                type: this.itype,
                questionText: this.iquestionText ? this.iquestionText : '',
                pictureUrl: this.ipictureUrl,
                options: this.ioptions,
                updateTrigger: false,
                optionAddingOngoing: false,
                suggestedAnswerOid: this.isuggestedAnswerOid,
            };
        },

        mounted: function() {
            this.updateTrigger = true;
            this.forceUpdate();
            $('#' + this.qid + 'level').focus();
        },

        computed: {
            suggestedAnswerIsFilled: function() {
                const options = Object.values(this.$refs.options);
                return options.some(option => option.oid === this.suggestedAnswerOid && option.optionText.trim() !== '');
            },

            hasOptionWithLatexSyntax: function() {
                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return false;
                }

                for (let index in this.$refs.options) {
                    let option = this.$refs.options[index];

                    if ((option.optionText.match(/\$/g) || []).length >= 2) {
                        return true;
                    }
                }

                return false;

            },
            correctOptionsCount: function() {
                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return 0;
                }

                let correctCount = 0;
                for (let index in this.$refs.options) {
                    let option = this.$refs.options[index];

                    // options that aren't filled out don't count!
                    if (option.optionText.trim() === '') {
                        continue;
                    }

                    if (option.isCorrect) {
                        correctCount++;
                    }
                }

                return correctCount;
            },

            correctOptionsCountInclEmpty: function() {
                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return 0;
                }

                let correctCount = 0;
                for (let index in this.$refs.options) {
                    if (this.$refs.options[index].isCorrect) {
                        correctCount++;
                    }
                }

                return correctCount;
            },
            incorrectOptionsCount: function() {
                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return 0;
                }

                let incorrectCount = 0;
                for (let index in this.$refs.options) {
                    let option = this.$refs.options[index];

                    // options that aren't filled out don't count!
                    if (option.optionText.trim() === '') {
                        continue;
                    }

                    if (!option.isCorrect) {
                        incorrectCount++;
                    }
                }

                return incorrectCount;
            },

            validationErrorMessage: function() {

                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return 'Loading...';
                }

                if (this.type === null) {
                    return 'You have to select a type for this question!';
                }

                if (this.questionText.trim() === '') {
                    return 'You have to fill out the question-text!';
                }

                if (this.options.length === 0) {
                    return 'There are neither correct nor incorrect options here! Please report this to the Tech team!';
                }

                switch (this.type) {
                    case 'singleChoice':
                        if (this.correctOptionsCount === 0) {
                            return 'You have to add and fill out at least one correct option to this question!';
                        }
                        if (this.incorrectOptionsCount === 0) {
                            return 'You have to add and fill out at least one incorrect option to this question!';
                        }
                        if (this.correctOptionsCount > 1) {
                            return 'You have to remove all but one correct options!';
                        }
                        break;
                    case 'multiChoice':
                        if (this.correctOptionsCount <= 1) {
                            return 'You have to add and fill out at least two correct options to this question!';
                        }
                        if (this.incorrectOptionsCount === 0) {
                            return 'You have to add and fill out at least one incorrect option to this question!';
                        }
                        break;
                    case 'freeText':
                        if (this.incorrectOptionsCount > 0) {
                            return 'You have to remove all incorrect options from this question!';
                        }
                        if (this.hasOptionWithLatexSyntax) {
                            return 'An option has LaTeX syntax. Free-Text options cannot have more than 1 Dollar-sign.';
                        }
                        if (!this.suggestedAnswerIsFilled) {
                            return 'You have to choose and fill out a suggested answer for freeText questions!';
                        }
                        break;
                    default:
                        return 'This Question does not have a valid type!';
                }

                for (let index in this.$refs.options) {
                    let option = this.$refs.options[index];
                    if ('optionText' in option) {
                        if (option.optionText.trim() === '') {
                            return 'All options have to be filled out!';
                        }
                    }
                }

                return null;
            },
        },

        methods: {
            isSuggestedAnswer(oid) {
                return oid === this.suggestedAnswerOid;
            },

            setSuggestedAnswer(oid) {
                this.suggestedAnswerOid = oid;
                this.forceUpdate();
            },

            uploadImage() {
                _(this.qid + '_quizImage').focus();
            },
            newImageUploaded(newUrl) {
                this.pictureUrl = newUrl;
            },

            generateUuid() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16),
                );
            },

            forceUpdate: function() {
                this.updateTrigger = false;
                this.updateTrigger = true;
                this.validate();
                this.$forceUpdate();
                this.$emit('forceUpdate');
            },

            validate: function() {
                let messageElem = $('#' + this.qid + '_message');

                if (this.validationErrorMessage != null) {
                    messageElem.removeClass('text-success');
                    messageElem.addClass('text-danger');
                    messageElem.innerHTML = this.validationErrorMessage;
                    return false;
                } else {
                    messageElem.removeClass('text-danger');
                    messageElem.addClass('text-success');
                    messageElem.innerHTML = 'This question seems valid!';
                    return true;
                }
            },

            camelCaseToWords: (camelCased) => {
                return camelCased.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + camelCased.replace(/([A-Z])/g, ' $1').slice(1);
            },

            getIsCorrect: function() {
                switch (this.type) {
                    case 'singleChoice':
                        // add correct option only if there is no correct one yet; otherwise add incorrect option.
                        return this.correctOptionsCountInclEmpty === 0;
                    case 'multiChoice':
                        // add correct option only if there aren't two correct ones yet; otherwise add incorrect option.
                        return this.correctOptionsCountInclEmpty <= 1;
                    case 'freeText':
                        // only correct options make sense here.
                        return true;
                }
            },
        },
    };
</script>
